import { registerFeatureMessages, type SupportedLocale } from '@/shared/i18n'

export function registerAlertMessages(locale: SupportedLocale): Promise<void> {
  return registerFeatureMessages('alerts', locale)
}
